export const FEATURE_FLAGS = {
  heliosEmail: "helios-email",
  /**
   * Gates the chip-based segment editor (SegmentFormV2). When this flag
   * is on, the create + edit segment pages render the new editor; when
   * off, they fall back to the legacy SegmentForm.
   */
  heliosSegmentsNew: "helios-segments-new",
  /**
   * Gates the texting QR code generator. When this flag is on, the
   * `/qr-codes` page and its sidebar nav item are available; when off,
   * the nav item is hidden and the page redirects away.
   */
  heliosQrCode: "helios-qr-codes",
  /**
   * Gates the new stepped DateTimePicker (date → time → review) for blast
   * scheduling. When on, the blast "Select time" radio renders the new
   * datetime field; when off, it falls back to the legacy DateTimeField.
   */
  heliosDatetimeFieldNew: "helios-datetime-field-new",
  /**
   * Gates browser-based voice calling (Twilio Voice JS SDK). When on, the
   * web app can place and receive calls: call buttons appear in the thread
   * header and contact sidebar, the incoming-call preferences section shows
   * in settings, and the voice device registers for incoming calls.
   */
  heliosWebCalling: "helios-web-calling",
  /**
   * Gates the Tasks feature. When on, the `/tasks` page and the Inbox
   * Tasks tab are available, along with task entry points in the contact
   * sidebar, thread header, inbox create menu, and flow editor.
   */
  heliosTasks: "helios-tasks",
  /**
   * Gates Ask Helios. When on, the `/pulse/ask` pages, the Ask Helios tab on
   * Pulse, and the Pulse detail conversation are available; when off, those
   * surfaces redirect or hide.
   */
  heliosAssistant: "helios-assistant",
  /**
   * Gates the gym-level Helios Web SDK installation page. Form share links
   * continue to work independently of this rollout flag.
   */
  heliosWebSdk: "helios-web-sdk",
  /**
   * Gates the Brand kit settings page and import wizard. When on, Brand kit
   * appears under Settings > Inbox; when off, the nav item is hidden and the
   * page redirects away.
   */
  heliosBrandKit: "helios-brand-kit",
  /**
   * Gates the Pages surface. When on, the sidebar shows Pages (a combined
   * list of forms and landing pages) instead of Forms, `/forms` redirects
   * to `/pages`, and the landing page builder routes are available; when
   * off, the Forms nav item and index render as before.
   */
  heliosPages: "helios-pages",
  /**
   * Gates the Pulse feed. When on, the `/pulse` routes and sidebar item are
   * available; when off, the nav item is hidden and the pages redirect to
   * `/messages`. Login lands on `/messages` either way.
   */
  heliosPulse: "helios-pulse",
  /**
   * Gates Stages. When on, the `/stages` board and sidebar item are
   * available and the Flows and Lists indexes show the playbook highlights
   * and lifecycle tag chips; when off, the nav item is hidden, `/stages`
   * redirects to `/messages`, and the playbook UI stays out of the indexes.
   */
  heliosStages: "helios-stages",
  /**
   * Gates the key insight card in the contact sidebar. When on, the card
   * renders (and its read triggers server-side generation); when off, the
   * sidebar renders without it and no insight requests are made.
   */
  heliosKeyInsight: "helios-key-insight",
} as const;

export type FeatureFlagKey = keyof typeof FEATURE_FLAGS;
export type FeatureFlag = (typeof FEATURE_FLAGS)[FeatureFlagKey];
